import { DEBUG_KEY } from '../constants';
/**
 * Read the `ms_debug` localStorage escape hatch. Fails closed: storage can throw
 * outright in a third-party iframe or with cookies blocked, and a debug switch
 * must never be the reason a publisher's page breaks.
 */
function readStoredFlag() {
    try {
        return localStorage.getItem(DEBUG_KEY) === '1';
    }
    catch {
        return false;
    }
}
/**
 * Module-global rather than per-instance because most loggers here are
 * module-scoped and have no instance to read from. Turning it on is one-way:
 * every source ORs into it, so a publisher passing `dev: false` can never
 * defeat the `ms_debug` hatch or a staging build.
 *
 * `__MS_DEBUG_DEFAULT__` is substituted at build time (see rollup.config.js):
 * true on the staging channel, false on prod. In a prod bundle this collapses
 * to `false || readStoredFlag()` — one localStorage read per page load.
 */
let enabled = __MS_DEBUG_DEFAULT__ || readStoredFlag();
/** Turn debug logging on for the rest of the page. Never turns it back off. */
export function enableDebugLogging() {
    enabled = true;
}
function resolveArgs(args) {
    return args.map(arg => (typeof arg === 'function' ? arg() : arg));
}
/**
 * The one console gate for the whole SDK. `scope` becomes the `[MS:scope]`
 * prefix, so no call site writes a prefix of its own.
 */
export function createDebugLogger(scope) {
    const prefix = `[MS:${scope}]`;
    return {
        log: (...args) => {
            if (!enabled)
                return;
            console.log(prefix, ...resolveArgs(args));
        },
        warn: (...args) => console.warn(prefix, ...args),
        error: (...args) => console.error(prefix, ...args),
    };
}
